import type { RecastConfig } from '@recast-navigation/core';
import type { SoloNavMeshGeneratorIntermediates } from '@recast-navigation/generators';

export interface NavMeshWorkerPayload {
  jobId: string;
  positions: Float32Array;
  indices: Uint32Array;
  keepIntermediates?: boolean;
  config?: Partial<RecastConfig>;
}

export enum NavMeshWorkerResponseType {
  Complete = 'complete',
  Progress = 'progress',
}

export interface NavMeshWorkerCompleteResponse {
  type: NavMeshWorkerResponseType.Complete;
  jobId: string;
  navMesh: Uint8Array<ArrayBufferLike>;
  success: boolean;
  intermediates: SoloNavMeshGeneratorIntermediates;
}

export interface NavMeshWorkerProgressResponse {
  type: NavMeshWorkerResponseType.Progress;
  jobId: string;
  progress: number;
  message?: string;
}

export type NavMeshWorkerResponse = NavMeshWorkerCompleteResponse | NavMeshWorkerProgressResponse;
